import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const getUniquePaths = (paths = []) => {
  return [...new Set(paths.filter(Boolean))];
};

const useQuickAccessPreferencesStore = create(
  persist(
    (set) => ({
      pinnedPaths: [],
      orderedPaths: [],

      togglePinnedPath: (path) => {
        if (!path) return;

        set((state) => {
          const isPinned = state.pinnedPaths.includes(path);

          return {
            pinnedPaths: isPinned
              ? state.pinnedPaths.filter((pinnedPath) => pinnedPath !== path)
              : getUniquePaths([...state.pinnedPaths, path]),
          };
        });
      },

      setOrderedPaths: (paths) => {
        set({
          orderedPaths: getUniquePaths(paths),
        });
      },
    }),
    {
      name: 'quick-access-preferences-storage',
      version: 1,
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useQuickAccessPreferencesStore;
